import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SectionHeading from "@/components/SectionHeading";
import Gallery from "@/components/Gallery";
import HeroSection from "@/components/HeroSection";

const VelikoformatnaKeramika = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <HeroSection
          title="Velikoformatna keramika"
          subtitle="Velike ploščice za brezšivne površine"
          imageSrc="/placeholder.svg"
          primaryButtonText="Zahtevaj ponudbo"
          primaryButtonLink="/kontakt"
        />
        
        <div className="container-custom mx-auto py-16">
          <SectionHeading
            title="Velikoformatna keramika"
            subtitle="Velike ploščice za brezšivne površine"
          />
          
          <div className="mt-8 prose prose-lg max-w-none">
            <p>
              Velikoformatne keramične ploščice omogočajo ustvarjanje velikih, skoraj brezšivnih površin z minimalnimi fugami.
              Idealne so za sodobne prostore, kjer želite ustvariti občutek prostornosti in kontinuitete.
            </p>
          </div>
          
          <Gallery
            images={[
              { src: "/placeholder.svg", alt: "Velikoformatna keramika 1" },
              { src: "/placeholder.svg", alt: "Velikoformatna keramika 2" },
              { src: "/placeholder.svg", alt: "Velikoformatna keramika 3" },
              { src: "/placeholder.svg", alt: "Velikoformatna keramika 4" },
            ]}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default VelikoformatnaKeramika;